export default "__VITE_ASSET__Db9v3fdi__"